import { Component, OnInit, ViewChild, ElementRef, TemplateRef } from '@angular/core'

import { sla, kpiRelease, quater, year, kpiInbox, slakpiperformance, kpiDashboard_MoroDigitalInfra } from './../../../models/slakpi';
import { division } from './../../../models/admin';
import { UtilityService } from './../../../services/utility.service';
import { SLAKPIApiService } from './../../../services/slakpi.service';
import { AdminApiService } from './../../../services/admin.service';
import { UserService } from './../../../services/user.service';
import { SpinnerVisibilityService } from 'ng-http-loader';

import { Router, ActivatedRoute, Params } from '@angular/router';
import { KPIAllHistoryComponent } from './../../../component/slakpi/kpi-allhistory/kpi-allhistory.component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
//import { EChartOption } from 'echarts';
import { uniqBy } from 'lodash';
declare var google: any;
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  MenuCallbackArgs,

} from 'angular-slickgrid';
@Component({
  selector: 'app-slakpi-performance.component',
  templateUrl: './slakpi-performance.component.html',
  styleUrls: ['./slakpi-performance.component.css']

})
export class SLAKPIPerformanceComponent implements OnInit {
  public sli_data: any;
  modalRef: BsModalRef;
  public slakpiPerformance_data: any;
  public yearData: any;
  public quaterData: any;
  public division_data: any;
  public frequency_data: any;
  public resettype_data: any;
  public slaUno?: any = 0;
  public yearUno?: any = 0;
  public quarterUno?: any = 0;
  public monthUno?: any = 0;
  public monthData: any;
  public monthBasedQuarterData: any;

  public divisionUno?: any = 0;
  public frequencyUno?: any = 0;
  public objkpiRelease: kpiRelease;
  public isback: boolean = false;
  columnDefinitions: Column[];
  columnDigitalDefinitions: Column[];
  gridOptions: GridOption;
  public loading: boolean = true;
  angularGrid: AngularGridInstance;
  dataset: any;

  public filterSettings: Object;
  public toolbar: string[];
  public pageSettings: Object;
  public formatoptions: Object;

  objDashboardList: any = [];
  //public loggined_User: number = 2;
  //for Users Default Value
  user: any = {};
  login_UserID: string; // number
  currentYear?: number;
  currentHalf?: number;
  currentQuarter?: number;
  currentMonth?: number;
  
  wellperformKPIRange?: number;
  isToggle: boolean = true;
  isPageLoad: boolean = true;
  chartOptionpie01: any = {};
  //for Users Permission
  public permision_add: boolean = false;
  public permision_edit: boolean = false;
  public permision_delete: boolean = false;

  isAdmin: boolean = false;
  isKpichartload: boolean = true;

  public Qyearsla: number = 0;
  public Qmonthsla: number = 0;
  public Qquatersla: number = 0;
  public Qdivisionsla: number = 0;
  public QPerformance: number = 0;
  public QpageType?: string = 'main';
  public Qpillar?: string = '';
  //for KPI All Hisory Dialog

  public kpiUnoSelected: number = 0;
  public kpinameSelected: string = '';
  @ViewChild('KPIAllHistoryDialog', { static: false }) KPIAllHistoryDialog: TemplateRef<any>;
  public position_history: object = { X: 70, Y: 100 };

  //for chart
  public position_chart: object = { X: 150, Y: 150 };
  
  public ChartKPIdatamain: any;
  //@ViewChild("inpyeardata_chart", { static: false }) inpyeardata_chart: DropDownListComponent;
  //@ViewChild("inpyeardata_chart_Q", { static: false }) inpyeardata_chart_Q: DropDownListComponent;
  //@ViewChild("inpquaterdata_chart", { static: false }) inpquaterdata_chart: DropDownListComponent;
  //@ViewChild("inpyeardata_chartType", { static: false }) inpyeardata_chartType: DropDownListComponent;
  public yearUno_chart: number = 0;
  public quaterUno_chart: number = 0;
  public isStart: boolean = true;
  //chart
  //Initializing Primary X Axis
  public primaryXAxis: Object = {
    valueType: 'Category',
    zoomFactor: 0.7
  };
  public primaryYAxis: Object = {
    title: 'Value',
    majorTickLines: { width: 0 }, majorGridLines: { width: 1 },
    minorGridLines: { width: 1 }, minorTickLines: { width: 0 }


  };

  public titlechart = 'KPI Chart';
  public zoomSettings: Object = {
    mode: 'X',
    enableMouseWheelZooming: true,
    enablePinchZooming: true,
    enableSelectionZooming: true,
    enableScrollbar: true
  };
  public marker: Object;
  public tooltip: Object;
  public palette: string[];
  public loadedChartVal: any;
  public ChartinpType: string = 'y';
  public chartTypedata: any;
    searchText: string;
  dataSearch: any[];
  noDataImg: any;
  tenantUno: any;
    WPCount: any=0;
    NWPCount: any=0;
  listPerformance: any = [];
  isDigitalDewa: boolean = false;
    QpageTypeName: any='';
    slaName: any;
  constructor(public restApi: SLAKPIApiService, private _activatedRoute: ActivatedRoute, public adminService: AdminApiService, private modalService: BsModalService,
    private userService: UserService, public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private kpiAllHistoryComponent: KPIAllHistoryComponent) {
    this._activatedRoute.queryParams.subscribe((params: Params) => {
      this.QpageType = (params['pagetype'] != null && params['pagetype'] != '') ? String(params['pagetype']) : 'main';
      this.Qyearsla = (params['yearsla'] != null && params['yearsla'] != '') ? Number(params['yearsla']) : 0;
      this.Qquatersla = (params['quatersla'] != null && params['quatersla'] != '') ? Number(params['quatersla']) : 0;
      this.Qmonthsla = (params['monthsla'] != null && params['monthsla'] != '') ? Number(params['monthsla']) : 0;
      this.Qdivisionsla = (params['divisionsla'] != null && params['divisionsla'] != '') ? Number(params['divisionsla']) : 0;

      this.QPerformance = (params['performance'] != undefined && params['performance'] != null && params['performance'] != '') ? Number(params['performance']) : 0;

      this.Qpillar = (params['pillarType'] != null && params['pillarType'] != '') ? String(params['pillarType']) : '';
      if (this.Qyearsla > 0) this.isback = true;

      this.QpageTypeName = this.QpageType;
    });
    //To Validate User Permission
    this.user = this.userService.getUserInfo();
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.isAdmin = (this.user.role == 'Administrator') ? true : false;
    if (!this.isAdmin) {
      this.CheckUserPermission();
    }
    else {
      this.permision_add = true;
      this.permision_edit = true;
      this.permision_delete = true;

    }

    this.tooltip = { enable: true };
    this.marker = {
      visible: true, width: 10, height: 10, dataLabel: { visible: true }, border: { width: 2, color: 'red' },
      rx: 10, ry: 10
    };
    this.palette = ["#07682d", "#e34867", "#6FAAB0", "#C4C24A"];

    
    this.login_UserID = this.user.id;
    this.currentYear = this.user.currentYear;
    this.currentHalf = this.user.currentHalf;
    this.currentQuarter = this.user.currentQuarter;
    this.currentMonth = this.user.currentMonth;
    this.wellperformKPIRange = this.user.wellperformKPIRange;
    this.yearUno = this.currentYear;
    this.quarterUno = this.currentQuarter;
    this.isDigitalDewa = (this.user.tenantDigitalUser == 'true') ? true : false;
    this.slaName = this.user.slaname;
    
  }
  ngOnInit() {
    this.userService.CheckLogin();
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 100
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
   
    this.objkpiRelease = new kpiRelease();

    //Load Default filter values
   // this.loadDivisions();
    this.loadFilterValues();
    this.loadMonth();
    this.loadFrequency();
    this.getChartType();
    this.toolbar = ['Search', 'ExcelExport'];
    this.pageSettings = { pageSize: 20, pageSizes: true };
    this.filterSettings = { type: 'Excel' };
    this.formatoptions = { type: 'date', format: 'dd/MM/yyyy' };
    //this.wrapSettings = { wrapMode: 'Content' };
    // setTimeout(() => { this.ResetDialog.hide(); }, 100);

    
    //google.charts.load('current', { 'packages': ['corechart'] });   
    //google.charts.setOnLoadCallback(this.drawMoroHubPieChartm);
   
  }
  //To Validate Current User - Page Level Permission
  CheckUserPermission() {

    //let userPermissionData = this.userService.getUserRights("SLA KPI Performance");
    //if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
    //  if (userPermissionData[0].showPage == 1) {
    //    this.permision_add = (userPermissionData[0].showAdd == 1) ? true : false;
    //    this.permision_edit = (userPermissionData[0].showEdit == 1) ? true : false;
    //    this.permision_delete = (userPermissionData[0].showDelete == 1) ? true : false;
    //    
    //    //User rights

    //    //this.toolbar = this.userService.getRights_Toolbar(this.permision_add, this.permision_edit, this.permision_delete);

    //  }
    //  else {
    //    this.router.navigateByUrl('/access-denied');
    //  }
    //}
    //else {
    //  this.router.navigateByUrl('/access-denied');
    //}
    this.permision_add = true;
    this.permision_edit = true;
    this.permision_delete = true;
  }

  viewKPIHistoryAll(kpiUno: any, kpiNameEn: any) {
    this.kpiUnoSelected = kpiUno;
    this.kpinameSelected = kpiNameEn;
    this.modalRef = this.modalService.show(
      this.KPIAllHistoryDialog,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }
  //Load Frequency Values
  loadFilterValues() {
    this.spinner.show();
    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.isStart = true;
    this.restApi.getKPITranFilterValues(inpValue)
      .subscribe(data => {
        
        let objdata: any = data;
        this.sli_data = objdata.list_SLAMaster;
        this.division_data = objdata.list_DivisionMaster;
        this.quaterData = objdata.list_QuarterMaster;
        this.yearData = objdata.list_YearMaster;

        setTimeout(() => {

          this.yearUno = (this.Qyearsla > 0) ? this.Qyearsla : Number(this.yearUno);

          this.quarterUno = (this.Qquatersla > 0) ? this.Qquatersla : Number(this.quarterUno);

          this.monthUno = (this.Qmonthsla > 0) ? this.Qmonthsla : Number(this.monthUno);
          if (this.Qdivisionsla > 0) {
            this.divisionUno = Number(this.Qdivisionsla);
          }

          if (this.QpageType != 'main') {
            let divisionFilterList = this.division_data.filter(s => s.divisionNameEn.toLocaleLowerCase() == this.QpageType.toLocaleLowerCase());
            if (divisionFilterList != null && divisionFilterList.length > 0) {
              this.divisionUno = divisionFilterList[0].divisionUno;
            }
          }

          if (this.Qpillar != '') {
            let slaFilterList = this.sli_data.filter(s => s.slaNameEn.toLocaleLowerCase() == this.Qpillar.toLocaleLowerCase());
            if (slaFilterList != null && slaFilterList.length > 0) {
              this.slaUno = slaFilterList[0].slaUno;
            }
          }

          this.loadSlaKpiPerformance(3); //by filter
          this.isStart = false;
          this.getDashbordList();
        }, 30);

        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }
  // Get sla list
  loadSLA() {
    this.spinner.show();
    let inpValue = new sla();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;

    this.restApi.getSLAs(inpValue)
      .subscribe(data => {
        
        this.sli_data = data;
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  // Get Year / Quater
  loadYear() {

    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    
    this.restApi.getYearMaster(inpValue)
      .subscribe(data => {
        
        this.yearData = data;
        //this.inpyeardata.addItem({ text: 'All', value: '0' }, 0);
        setTimeout(() => {

          this.yearUno = (this.Qyearsla > 0) ? this.Qyearsla : Number(this.yearUno);
        }, 10);
      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }
  loadQuater() {

    let inpValue = new quater();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    
    this.restApi.getQuaterMaster(inpValue)
      .subscribe(data => {
        
        this.quaterData = data;

        setTimeout(() => {

          this.quarterUno = (this.Qquatersla > 0) ? this.Qquatersla : Number(this.quarterUno);
        }, 10);

      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }

  loadDivisions() {

    let inpValue = new division();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getDivisions(inpValue)
      .subscribe(data => {
        
        this.division_data = data;

        if (this.Qdivisionsla > 0)
          setTimeout(() => {
            this.divisionUno = Number(this.Qdivisionsla);
          }, 10);

        if (this.QpageType !='main') {
          let divisionFilterList = this.division_data.filter(s => s.divisionNameEn.toLocaleLowerCase() == this.QpageType.toLocaleLowerCase());
          if (divisionFilterList != null && divisionFilterList.length > 0) {
            this.divisionUno = divisionFilterList[0].divisionUno;
          }
        }
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }


  loadFrequency() {
    if (this.isDigitalDewa == false) {
      this.frequency_data = [];
      this.frequency_data = [
        { frequencyCode: 1, frequencyName: 'Yearly' },
        { frequencyCode: 2, frequencyName: 'Semi-annually' },
        { frequencyCode: 3, frequencyName: 'Quarterly' }
        //{ frequencyCode: 4, frequencyName: 'Monthly' }
      ];
    }

    if (this.isDigitalDewa == true || this.tenantUno == 5) {
      this.frequency_data = [];
      this.frequency_data = [
        { frequencyCode: 1, frequencyName: 'Yearly' },
        { frequencyCode: 2, frequencyName: 'Semi-annually' },
        { frequencyCode: 3, frequencyName: 'Quarterly' },
        { frequencyCode: 4, frequencyName: 'Monthly' }
      ];
    }
  }


  // Get SlaKpiPerformance list
  loadSlaKpiPerformance(condition) {
    
    this.loading = true;
    let inpValue = new slakpiperformance();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = condition;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    inpValue.slaUno = (this.slaUno == 0 || this.slaUno == undefined) ? 0 : this.slaUno; 
    inpValue.kpiyear = (this.yearUno == 0 || this.yearUno == undefined) ? this.currentYear : this.yearUno;
    inpValue.kpiyearTo = inpValue.kpiyear.toString();
    inpValue.kpiquarter = (this.quarterUno == 0 || this.quarterUno == undefined) ? this.currentQuarter : this.quarterUno;
    inpValue.divisionUno = (this.divisionUno == 0 || this.divisionUno == undefined) ? 0 : this.divisionUno; 
    inpValue.frequencyUno = (this.frequencyUno == 0 || this.frequencyUno == undefined) ? 0 : this.frequencyUno;
    inpValue.half = this.currentHalf;
    inpValue.month = (this.monthUno == 0 || this.monthUno == undefined) ? 0 : this.monthUno;
    inpValue.wellperformKPIRange = this.wellperformKPIRange;

    inpValue.kpiquarter = (inpValue.kpiquarter > 0) ? inpValue.kpiquarter : (this.monthUno != 0 && this.monthUno != undefined) ? this.getMonthQuarter() : this.currentQuarter;


    this.restApi.getSlaKpiPerformance(inpValue)
      .subscribe(data => {
        

        if (this.QPerformance > 0) {
          let objdata: any = data;
          this.slakpiPerformance_data = objdata.filter(s => s.bandValue == this.QPerformance);
        }
        else {
          this.slakpiPerformance_data = data;
        }
        const mockDataset = [];
        for (let i = 0; i < this.slakpiPerformance_data.length; i++) {
          mockDataset[i] = {
            id: i + 1,
            kpiTrnUno: this.slakpiPerformance_data[i].kpiTrnUno,
            kpiCode: this.slakpiPerformance_data[i].kpiCode,
            kpiName: this.slakpiPerformance_data[i].kpiName,
            divisionName: this.slakpiPerformance_data[i].divisionName,
            year: this.slakpiPerformance_data[i].year,
            quarter: this.slakpiPerformance_data[i].quarter,
            periodDisplay: this.slakpiPerformance_data[i].periodDisplay,
            type: this.slakpiPerformance_data[i].type,
            actualValueText: this.slakpiPerformance_data[i].actualValueText,
            targetValueText: this.slakpiPerformance_data[i].targetValueText,
            kpiRule: this.slakpiPerformance_data[i].kpiRule,
            bandValueText: this.slakpiPerformance_data[i].bandValueText,
            bandValue: this.slakpiPerformance_data[i].bandValue,
            slaRuleUno: this.slakpiPerformance_data[i].slaRuleUno,
            kpiUno: this.slakpiPerformance_data[i].kpiUno,
            isNANRNT: this.slakpiPerformance_data[i].isNANRNT,
            actualValue: this.slakpiPerformance_data[i].actualValue,
          };
        }
        this.dataset = mockDataset;
        this.dataSearch = mockDataset;
        if (mockDataset.length > 0) {
          this.setColnDefn();
        }
        this.loading = false;
        
        this.isPageLoad = false;
      },
        (error) => {
          //Called when error
          this.loading = false;
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }



  drawertoggle() {
    
    this.isToggle = (this.isToggle) ? false : true;
  }

  // Choose city using select dropdown

  // Choose city using select dropdown
  onchangeSLA(e) {
    
    //alert(e.itemData.slaUno);
    this.slaUno = (e.length == 0 || e[0].value == 'All') ? 0 : e[0].value;
    this.onSelectedTab();

  }
  onchangeYear(e) {
    
    this.yearUno = (e.length == 0 || e[0].value == 'All') ? 0 : e[0].value;
    this.onSelectedTab();
  }


  onchangeQuarter(e) {
    this.quarterUno = (e.length == 0 || e[0].value == 'All') ? 0 : e[0].value;

    this.monthBasedQuarterData = [];
    if (this.quarterUno == 0) { this.monthBasedQuarterData = this.monthData; }
    let filterMonth = this.monthData.filter(x => x.Quarter == this.quarterUno);
    for (let month of filterMonth) {
      this.monthBasedQuarterData.push(month);
    }
    this.monthBasedQuarterData = this.sortByKeyAsc(this.monthBasedQuarterData, "value");

    this.onSelectedTab();
  }
  onchangeMonth(e) {
    
    this.monthUno = (e.length == 0 || e[0].value == 'All') ? 0 : e[0].value;
    this.onSelectedTab();
  }

  onchangeDivision(e) {
    
    this.divisionUno = (e.length == 0 || e[0].value == 'All') ? 0 : e[0].value;

    if (e.length > 0) {
      this.QpageTypeName = e[0].text;
      this.QpageType = e[0].text;
    }
    this.onSelectedTab();
  }


  onchangeFrequency(e) {
    this.frequencyUno = (e && e.length > 0 && e[0].value == 'All') ? 0 : e[0].value;
    this.onSelectedTab();
  }

  onSelectedTab() {
    if (!this.isPageLoad) {
      if (this.QpageType != 'main' && ((this.divisionUno == 0 || this.divisionUno == undefined))) {
        let divisionFilterList = this.division_data.filter(s => s.divisionNameEn.toLocaleLowerCase() == this.QpageType.toLocaleLowerCase());
        if (divisionFilterList != null && divisionFilterList.length > 0) {
          this.divisionUno = divisionFilterList[0].divisionUno;
        }
      }
      this.loadSlaKpiPerformance(3);
      this.getDashbordList();
    }
      
    //by filter
  }



  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  exportToExcel() {
    var temp = this;
    setTimeout(function () {
      temp.angularGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }


  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val.trim();
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }

  searchGrid() {
    
    if (this.searchText != "") {
      this.dataset = this.dataSearch.filter(a =>
        a.kpiCode && a.kpiCode.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.kpiName && a.kpiName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.divisionName && a.divisionName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.year && a.year.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.quarter && a.quarter.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.type && a.type.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.actualValueText && a.actualValueText.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.targetValueText && a.targetValueText.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.kpiRule && a.kpiRule.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.bandValueText && a.bandValueText.toLowerCase().includes(this.searchText.toLowerCase())));
    }
    else
      this.dataset = this.dataSearch;
  }
  setColnDefn() {
    let temp = this;
    this.columnDefinitions = [
      {
        id: 'kpiCode', name: 'KPI Code', field: 'kpiCode', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiCode', 'kpiCode'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'kpiName', name: 'KPI', field: 'kpiName', sortable: true, width: 300,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiName', 'kpiName'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'divisionName', name: 'Division', field: 'divisionName', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'divisionName', 'divisionName'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'year', name: 'Year', field: 'year', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'year', 'year'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'quarter', name: 'Quarter', field: 'quarter', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'quarter', 'quarter'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'type', name: 'KPI Type', field: 'type', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'type', 'type'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'actualValueText', name: 'Actual', field: 'actualValueText', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'actualValueText', 'actualValueText'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'targetValueText', name: 'Target', field: 'targetValueText', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'targetValueText', 'targetValueText'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'kpiRule', name: 'KPI Rule', field: 'kpiRule', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiRule', 'kpiRule'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'bandValueText', name: 'Bands', field: 'bandValueText', selectable: false, type: FieldType.string, filterable: true, formatter: this.bandFormatter,
        filter: {
          collection: this.uniqueArray(this.dataset, 'bandValueText', 'bandValueText'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 50,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
            {
              command: 'KPI-Info-row', titleKey: 'KPIInfo_ROW', positionOrder: 62, title: 'KPI Info',

              iconCssClass: 'fa fa-info-circle fa-lg ', cssClass: 'green-text', textCssClass: 'bold',
              action: (e, args) => {
                this.viewKPIHistoryAll(args.dataContext.kpiUno, args.dataContext.kpiCode + ' : ' + args.dataContext.kpiName)
              }
            },

            //{
            //  command: 'KPI-row', titleKey: 'KPI_ROW', positionOrder: 65, title: 'KPI Chart',
            //  iconCssClass: 'fa fa-bar-chart fa-lg ', cssClass: 'red', textCssClass: 'bold',
            //  itemVisibilityOverride: (args: MenuCallbackArgs) => {
            //    let data = args.dataContext;
            //    debugger;
            //    if (data.slaRuleUno != 4 && data.slaRuleUno != 3)
            //      return true;
            //    else false;
            //  },

            //  action: (e, args) => {
            //    //this.sendKPIReset(args.dataContext);
            //  }
            //},


          ],
        }
      }
     
    ]


    this.columnDigitalDefinitions = [
      //{
      //  id: 'kpiCode', name: 'KPI Code', field: 'kpiCode', sortable: true,
      //  type: FieldType.string, filterable: true,
      //  filter: {
      //    collection: this.uniqueArray(this.dataset, 'kpiCode', 'kpiCode'),
      //    model: Filters.multipleSelect,
      //  }
      //},
      {
        id: 'kpiName', name: 'KPI Name', field: 'kpiName', sortable: true, width: 250,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiName', 'kpiName'),
          model: Filters.multipleSelect,
        }
      },
      
      {
        id: 'quarter', name: 'Quarter', field: 'quarter', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'quarter', 'quarter'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'periodDisplay', name: 'Period', field: 'periodDisplay', sortable: true, type: FieldType.string, filterable: true, width: 100,
        filter: {
          collection: this.uniqueArray(this.dataset, 'periodDisplay', 'periodDisplay'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'type', name: 'KPI Type', field: 'type', sortable: true, type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'type', 'type'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'actualValueText', name: 'Actual', field: 'actualValueText', sortable: true, type: FieldType.string, filterable: true, formatter: this.ValueFormatter,
        filter: {
          collection: this.uniqueArray(this.dataset, 'actualValueText', 'actualValueText'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'targetValueText', name: 'Target', field: 'targetValueText', sortable: true, type: FieldType.string, filterable: true, formatter:this.ValueFormatter,
        filter: {
          collection: this.uniqueArray(this.dataset, 'targetValueText', 'targetValueText'),
          model: Filters.multipleSelect,
        }
      },
      
      {
        id: 'bandValueText', name: 'Performance', field: 'bandValueText', selectable: false, type: FieldType.string, filterable: true, formatter: this.bandFormatter,
        filter: {
          collection: this.uniqueArray(this.dataset, 'bandValueText', 'bandValueText'),
          model: Filters.multipleSelect,
        }
      }

    ]
  }

  ValueFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    
    if (!isNaN(Number(value))) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    else
      return value;
  };

  bandFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    if (dataContext.bandValue == '1')
      return `<div class="bg-grey-progress" > <span class="green-bar"></span></div>`;
    if (dataContext.bandValue == '2')
      return `<div class="bg-grey-progress" > <span class="red-bar"></span></div>`;
    if (dataContext.bandValue != 1 && dataContext.bandValue != 2 && dataContext.bandValue == 0)
      return `<div class="bg-grey-progress" > <span class="bluedark-bar"></span></div>`;
  };

  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }


  backClick() {
    this.router.navigate(['/sladashboard/general'], { queryParams: { yearsla: this.yearUno, quatersla: this.quarterUno, divisionsla: this.divisionUno } });

  }
  historyPageRedirect() {
    this.router.navigate(['/slakpiperformancehistory'], { queryParams: { yearsla: this.yearUno, quatersla: this.quarterUno, divisionsla: this.divisionUno } });

  }
  viewKPIChartDialogOpen(kpiUno: any, kpiNameEn: any, isFilter: boolean) {
    this.kpinameSelected = kpiNameEn;
    this.titlechart = 'KPI Chart: ' + this.kpinameSelected;
    //this.inpyeardata_chartType.value = "Yearly";
    this.ChartinpType = "y";
    this.viewKPIChart(kpiUno, kpiNameEn, isFilter);
  }
  viewKPIChart(kpiUno: any, kpiNameEn: any, isFilter: boolean) {
    this.isKpichartload = true;
    this.ChartKPIdatamain = null;
    this.kpiUnoSelected = kpiUno;
    this.kpinameSelected = kpiNameEn;
    this.titlechart = (this.yearUno_chart == 0) ? 'KPI Chart: ' + this.kpinameSelected : 'KPI Chart [ ' + this.yearUno_chart + ' ]: ' + this.kpinameSelected;
    if (!isFilter) {
      // this.inpyeardata_chart.value = Number(this.yearUno);
      //this.inpyeardata_chart_Q.value = Number(this.yearUno);
      //this.yearUno_chart = this.currentYear;
      //this.yearUno_chart = 0;
      //this.quaterUno_chart = 0;
    }

    //Get The Chart Value
    
    this.spinner.show();
    let inpValue = new kpiInbox();
    inpValue.kpiUno = kpiUno;
    inpValue.kpiYear = this.yearUno_chart;
    inpValue.kpiQuarter = this.quaterUno_chart;
    inpValue.scheduleText = (this.ChartinpType == 'y') ? 'year' : 'quarter';
    inpValue.userUno = this.login_UserID;
    this.restApi.getKpiYearWiseChart(inpValue)
      .subscribe(data => {
        
        setTimeout(() => {
          this.ChartKPIdatamain = data;
          this.isKpichartload = false;
          this.spinner.hide();
          if (!isFilter) {
            //this.KPIChartDialog.show();
          }
        }, 1000);

        // let chartComponent1: any = getInstance('#chart-container', Chart);
        // chartComponent1.refresh();



      },
        (error) => {
          //Called when error
          this.spinner.hide();
          this.isKpichartload = false;
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        // this.spinner.hide();

      });



  }



  onchangeYear_Chart(e) {
    //if (!this.isStart) {
    this.yearUno_chart = (e.itemData != null) ? e.itemData.value : 0;
    this.viewKPIChart(this.kpiUnoSelected, this.kpinameSelected, true);
    //}
  }
  onchangeYear_Chart_Q(e) {
    //if (!this.isStart) {
    this.yearUno_chart = (e.itemData != null) ? e.itemData.value : 0;
    this.viewKPIChart(this.kpiUnoSelected, this.kpinameSelected, true);
    //}
  }
  onchange_ChartType(e) {
    


    if (e.itemData != null && e.itemData.value == 'Yearly') {
      this.quaterUno_chart = 0;
      this.ChartinpType = 'y';
      this.yearUno_chart = 0;
      this.quaterUno_chart = 0;
      if (!this.isStart) {
        // this.inpyeardata_chart.value = null;       
      }
      //  
    }
    else {
      this.ChartinpType = 'q';
      this.yearUno_chart = 0;
      this.quaterUno_chart = 0;
      if (!this.isStart) {

        //this.inpyeardata_chart_Q.value = Number(this.yearUno);
        // this.inpquaterdata_chart.value = null;

      }

    }
    let tempthis = this;
    //setTimeout(() => {
    
    if (!this.isStart) {
      this.viewKPIChart(this.kpiUnoSelected, this.kpinameSelected, true);
    }
    //}, 200);

  }
  onchangeQuarter_Chart(e) {
    if (!this.isStart) {
      this.quaterUno_chart = (e.itemData != null) ? e.itemData.value : 0;
      this.viewKPIChart(this.kpiUnoSelected, this.kpinameSelected, true);
    }
  }
  getChartType() {
    this.chartTypedata = [
      { text: 'Yearly', value: 'Yearly' },
      { text: 'Quarterly', value: 'Quarterly' }
    ];
  }
  //loadedChartDowload(args: ILoadedEventArgs) {
  //  this.loadedChartVal = args;

  //}
  //public loadChart(args: ILoadedEventArgs): void {
  //  
  //  args.chart.zoomModule.isZoomed = true;
  //};
  chartDownload() {
    // this.titlechart = 'KPI Chart: ' + this.kpinameSelected;

    this.loadedChartVal.chart.exportModule.export('PNG', 'export');
    //setTimeout(() => { this.titlechart = 'KPI Chart'; }, 300);

  }
  onDbClicked(ev, es) {
    let rdata = this.angularGrid.gridService.getDataItemByRowIndex(es.row)
    if (rdata != null && rdata != undefined) {
      //this.router.navigateByUrl('/kpi-performance-view/' + rdata.kpiTrnUno);

      this.router.navigate(['/kpi-performance-view/' + rdata.kpiTrnUno], { queryParams: { yearslakpi: this.yearUno} });
    }
    return false;
  }

  

  getDashbordList() {
    
    let inpValue = new kpiDashboard_MoroDigitalInfra();
    inpValue.userUno = this.login_UserID;
    inpValue.currentYear = (this.yearUno == 0 || this.yearUno == undefined) ? this.currentYear : this.yearUno;
    inpValue.currentQuarter = (this.quarterUno == 0 || this.quarterUno == undefined) ? this.currentQuarter : this.quarterUno; //this.quarterfilter ? this.quarterfilter : 0;
    inpValue.currentMonth = (this.monthUno == 0 || this.monthUno == undefined) ? 0 : this.monthUno;
    inpValue.reportingDivision = (this.divisionUno == 0 || this.divisionUno == undefined) ? 0 : this.divisionUno; 
    inpValue.tenantUno = this.tenantUno;
    inpValue.dashboardType = 'report';
    inpValue.targetPercentage = 50;
    inpValue.selectedQuarterFilter = (this.quarterUno == 0 || this.quarterUno == undefined) ? this.currentQuarter : this.quarterUno;


    inpValue.selectedQuarterFilter = (inpValue.selectedQuarterFilter > '0') ? inpValue.selectedQuarterFilter : (this.monthUno != 0 && this.monthUno != undefined) ? this.getMonthQuarter().toString() : this.currentQuarter.toString();

    this.restApi.getKPIDashboard_MoroDigitalInfra(inpValue)
      .subscribe(data => {
        
        if (data != null) {
          this.objDashboardList = data[0];
          //MoroHubPieChart
          
          if (this.QpageType.toLocaleLowerCase() == 'moro')
              this.listPerformance = this.objDashboardList.listMoroHubPerformance;
          

          
          if (this.QpageType.toLocaleLowerCase() == 'digitalx')
              this.listPerformance = this.objDashboardList.listDigitalXPerformance;
          
           
          if (this.QpageType.toLocaleLowerCase() == 'infrax')
              this.listPerformance = this.objDashboardList.listInfraXPerformance;
          

          if (this.listPerformance.length > 0) {
            this.spinner.show();
            setTimeout(() => {
              this.drawMoroHubPieChartm(this.listPerformance);
              this.spinner.hide();
            }, 200);
          }

          
        }

        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });


  }


  drawMoroHubPieChartm = (option_data: any) => {
    //  let tempArray = [['Moro Hub', 'Types of Reports Submitted']];
    //  let wellPerformanceCount = option_data.map(a => a.isWellPerformed).reduce(function (a, b) {
    //    return a + b;
    //  });

    //  let notwellPerformanceCount = option_data.map(a => a.isNotWellPerformed).reduce(function (a, b) {
    //    return a + b;
    //  });
    //  this.WPCount = wellPerformanceCount;
    //  this.NWPCount = notwellPerformanceCount;

    //  tempArray.push(['Well Performed', wellPerformanceCount]);
    //  tempArray.push(['Not Well Performed', notwellPerformanceCount]);
    //  var data = google.visualization.arrayToDataTable(tempArray);
    //  //const data = google.visualization.arrayToDataTable([
    //  //  ['Moro Hub', 'Types of Reports Submitted'],
    //  //  ['KPIs', 75],
    //  //  ['SLAs', 25],
    //  //]);

    //  const options = {
    //    //title: 'Types of Reports Submitted',
    //    colors: ['#68b097', '#bcbcbc'],
    //    legend: { position: 'none' },
    //    fontSize: 15,
    //    chartArea: { left: 5, right: 5, top: 10, bottom: 10, width: "90%", height: "100%" },
    //  };

    //  const chart = new google.visualization.PieChart(document.getElementById('Morohub_Pie'));
    //  chart.draw(data, options);
    //}

    let tempArray = [['Moro Hub', 'Types of Reports Submitted']];
    let wellPerformanceCount = option_data.map(a => a.isWellPerformed).reduce(function (a, b) {
      return a + b;
    });

    let notwellPerformanceCount = option_data.map(a => a.isNotWellPerformed).reduce(function (a, b) {
      return a + b;
    });
    this.WPCount = wellPerformanceCount;
    this.NWPCount = notwellPerformanceCount;

    let WPPercentage = Math.round((parseInt(wellPerformanceCount) / (parseInt(notwellPerformanceCount) + parseInt(wellPerformanceCount))) * 100);
    let NWPPercentage = Math.round((parseInt(notwellPerformanceCount) / (parseInt(notwellPerformanceCount) + parseInt(wellPerformanceCount))) * 100);

    //echarts starts
    this.chartOptionpie01 = {
      title: {
        text: '',
        //subtext: '纯属虚构',
        left: 'center'
      },
      color: ['#68b097', '#bcbcbc'],
      tooltip: {
        trigger: 'item',
        borderWidth: 0,
        backgroundColor: '#fff',
        textStyle: {
          color: '#212529'
        }


      },
      legend: {
        show: false,
        orient: 'vertical',
        left: 'right',
        align: 'left'
      },
      series: [
        {
          name: '',
          type: 'pie',
          radius: '80%',
          center: ['50%', '50%'],
          data: [
            //{ value: this.WPCount, name: WPPercentage +'%' },
            //{ value: this.NWPCount, name: NWPPercentage + '%'}
            { value: (this.WPCount == 0) ? '' : this.WPCount, name: (WPPercentage == 0) ? '' : WPPercentage + '%' },
            { value: (this.NWPCount == 0) ? '' : this.NWPCount, name: (NWPPercentage == 0) ? '' : NWPPercentage + '%' },

          ],
          label: {
            show: true,
            position: (WPPercentage == 100 || NWPPercentage == 100) ? 'inner' : 'inner',
            color: 'white',
            fontSize: 15
          },
          labelLine: {
            show: false
          },
          emphasis: {

            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    };
    //echarts ends
  }

  loadMonth() {
    this.monthData = [
      { value: 1, Quarter: 1, displayText: 'January' },
      { value: 2, Quarter: 1, displayText: 'February' },
      { value: 3, Quarter: 1, displayText: 'March' },
      { value: 4, Quarter: 2, displayText: 'April' },
      { value: 5, Quarter: 2, displayText: 'May' },
      { value: 6, Quarter: 2, displayText: 'June' },
      { value: 7, Quarter: 3, displayText: 'July' },
      { value: 8, Quarter: 3, displayText: 'August' },
      { value: 9, Quarter: 3, displayText: 'September' },
      { value: 10, Quarter: 4, displayText: 'October' },
      { value: 11, Quarter: 4, displayText: 'November' },
      { value: 12, Quarter: 4, displayText: 'December' }
    ];

    this.monthBasedQuarterData = this.monthData;
  }

  getMonthQuarter() {
    let rtnValue = this.currentQuarter;
    if (this.monthUno > 0 && this.monthUno <= 3)
      rtnValue = 1;
    if (this.monthUno > 3 && this.monthUno <= 6)
      rtnValue = 2;
    if (this.monthUno > 6 && this.monthUno <= 9)
      rtnValue = 3;
    if (this.monthUno > 9 && this.monthUno <= 12)
      rtnValue = 4;

    return rtnValue;
  }

  sortByKeyAsc(array, key) {
    return array.sort(function (a, b) {
      var x = a[key]; var y = b[key];
      return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
  }
}


